import { useQuery } from "@tanstack/react-query";
import ApiHttp from "byzantine/src/ApiHttp";

export interface MatchCandidateAccount {
  id: string;
  name: string;
}

export interface MatchCandidateTransaction {
  id: string;
  description: string;
  date: string;
  amount: string;
  account: MatchCandidateAccount;
}

export interface MatchCandidate {
  transaction: MatchCandidateTransaction;
  confidence_score: number;
  amount_delta: string | null;
}

export interface MatchCandidatesResponse {
  candidates: MatchCandidate[];
}

export const MATCH_CANDIDATES_QUERY_KEY = "receiptMatchCandidates";

// Candidates are computed live server-side, so a cached list is stale the
// moment it lands. Zero cache lifetimes + refetchOnMount make every modal
// open a fresh fetch.
export const useMatchCandidates = (receiptId: string | null) => {
  return useQuery<MatchCandidatesResponse>({
    queryKey: [MATCH_CANDIDATES_QUERY_KEY, receiptId],
    queryFn: () =>
      ApiHttp.fetch<MatchCandidatesResponse>(
        `receipts/${receiptId}/match-candidates/`,
        { method: "GET" }
      ),
    enabled: receiptId !== null,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: "always",
    retry: false,
  });
};
